import AXIOS from "@/axios";
import {
  Client,
  ClientFilterListResponse,
  ClientList,
  ClientQuery,
} from "@/types/client.model";
import { APIResponse } from "@/types/user.model";

export const getClientFilterService = ({ showAll }: { showAll: boolean }) => {
  const params: { [key: string]: number } = {};

  if (showAll) {
    params["xactive"] = 1;
  }

  return AXIOS.get<ClientFilterListResponse[]>("/base/dn/v1/client", {
    params,
  });
};

export const addClientService = (clientData: Client) => {
  return AXIOS.post<APIResponse<ClientList>>("/client/v1/create", clientData);
};

export const updateClientService = (clientId: string, clientData: Client) => {
  return AXIOS.put<APIResponse<ClientList>>(
    `/client/v1/update/${clientId}`,
    clientData
  );
};

export const getAllClientService = (clientQuery: ClientQuery) => {
  return AXIOS.get<APIResponse<ClientList[]>>("/client/v1/list", {
    params: clientQuery,
  });
};

export const getClientDetailService = (clientId: string) => {
  return AXIOS.get<APIResponse<ClientList>>(`/client/v1/view/${clientId}`);
};

// Fetch onboarding email details by email id
export const getOnboardEmailViewService = (emailId: string) => {
  return AXIOS.get(`/user/v1/email/view/${emailId}`);
};

// Fetch resend email template for a user
export const getResendTemplateService = (userId: string) => {
  return AXIOS.get(`/user/v1/resend-template/${userId}`);
};

// Resend email for a user
export const resendClientEmailService = (userId: string, payload: any) => {
  return AXIOS.post(`/user/v1/mail-resend/${userId}`, payload);
};

// Client Organization interface
export interface ClientOrganization {
  client_id: string;
  user_id: string;
  org_name: string;
}

// Fetch client organizations for the logged-in client user
export const getClientOrganizationsService = () => {
  return AXIOS.get<{ message: string; data: ClientOrganization[] }>(
    "/client/v1/info"
  );
};
